import { Link } from "react-router";

type FooterLinksProps = {
  testId?: string;
};

export function FooterLinks({ testId }: FooterLinksProps) {
  return (
    <div
      data-testid={`${testId}-footerLinks`}
      className="text-xs leading-4.5 not-italic"
    >
      <Link
        to="https://www.sph.com.sg/tnc/website"
        target="_blank"
        rel="noreferrer"
        className="text-red-100 hover:text-red-200 hover:underline"
      >
        Terms and Conditions
      </Link>
      <span className="text-grey-100 px-1"> |&nbsp;</span>
      <Link
        to="https://www.sph.com.sg/tnc/pdpa"
        target="_blank"
        rel="noreferrer"
        className="text-red-100 hover:text-red-200 hover:underline"
      >
        Personal Data Protection Notice
      </Link>
      <span className="text-grey-100 px-1"> | </span>
      <Link
        to="https://www.sph.com.sg/tnc/cookie"
        target="_blank"
        rel="noreferrer"
        className="text-red-100 hover:text-red-200 hover:underline"
      >
        Cookie Notice
      </Link>
    </div>
  );
}
